var savedPromises = {};

var removePromise = function removePromise(promiseName) {
  if (savedPromises) savedPromises[promiseName] = undefined;
};

var getPromise = function getPromise(promiseName) {
  return savedPromises && savedPromises[promiseName];
};

var createPromise = function createPromise(promiseName) {
  if (!savedPromises[promiseName]) {
    savedPromises[promiseName] = {};
    savedPromises[promiseName].Promise = new Promise(function (resolve, reject) {
      savedPromises[promiseName].Resolve = resolve;
      savedPromises[promiseName].Reject = reject;
    });
  }

  return savedPromises[promiseName];
};

var resolvePromise = function resolvePromise(promiseName, promiseData) {
  return savedPromises && savedPromises[promiseName] && savedPromises[promiseName].Resolve(promiseData);
};

var rejectPromise = function rejectPromise(promiseName, promiseData) {
  return savedPromises && savedPromises[promiseName] && savedPromises[promiseName].Reject(new Error(promiseData.reason || 'Failed to save document.'));
};

export default {
  createPromise: createPromise,
  getPromise: getPromise,
  removePromise: removePromise,
  resolvePromise: resolvePromise,
  rejectPromise: rejectPromise
};